import { useEffect, useState } from "react";
import { db } from "../services/firebase";
import { ref, onValue, off } from "firebase/database";
import { auth } from "../services/firebase";

// User profile 
export default function useFetchUserProfile() {

    const [profile, setProfile] = useState(null);
    const [loadingProfile, setLoading] = useState(true);

    useEffect(() => {
        const user = auth.currentUser;
        if (!user) {
            setLoading(false);
            return;
        }

        const profileRef = ref(db, `Users/Profile/${user.uid}/`);

        const unsubscribe = onValue(profileRef, (snapshot) => {
            const data = snapshot.val();
            setProfile(data || null);
            setLoading(false);
        });

        return () => {
            off(profileRef);
            unsubscribe();
        };
    }, []);

    return { profile, loadingProfile };
}
